import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/layout/index.vue'

Vue.use(Router)

// 修复路由重复报错问题
const methods = ['push', 'replace']
methods
  .map((key) => {
    return {
      k: key,
      prop: Router.prototype[key]
    }
  })
  .forEach((item) => {
    Router.prototype[item.k] = function newCall(
      location,
      onResolve,
      onReject
    ) {
      if (onResolve || onReject) {
        return item.prop.call(this, location, onResolve, onReject)
      }
      return item.prop.call(this, location).catch((err) => err)
    }
  })

const routesAll = [
  {
    path: '/',
    redirect: '/home',
    component: Layout,
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/index')
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import('@/views/aboutUs/index')
      },
      {
        path: '/businessIntroduction',
        name: 'businessIntroduction',
        component: () => import('@/views/businessIntroduction/index')
      },
      {
        path: '/judicialbusiness',
        name: 'judicialbusiness',
        component: () => import('@/views/judicialbusiness/index.vue')
      },
      {
        path: '/caseIntroduction',
        name: 'caseIntroduction',
        component: () => import('@/views/caseIntroduction/index')
      },
      {
        path: '/consultationList',
        name: 'consultationList',
        component: () => import('@/views/consultationList/index')
      },
      {
        path: '/consultationDetails',
        name: 'consultationDetails',
        component: () => import('@/views/consultationDetails/index')
      }
    ]
  }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  base: '/',
  scrollBehavior: () => ({ y: 0 }),
  routes: routesAll
})

const router = createRouter()

router.beforeEach((to, from, next) => {
  next() // 继续导航
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  Router.match = newRouter.match // reset router
}

export default router
